module.exports = __webpack_public_path__ + "img/success.6bc2f186.svg";